import LyButton from './src/index.vue'

LyButton.install = function (Vue) {
    Vue.component(LyButton.name, LyButton)
}

export default LyButton



//////////////////
// WEBPACK FOOTER
// ../projectCore/src/components/button/index.js
// module id = null
// module chunks = 